import React from 'react';
import Features from '../components/Features';
import Download from '../components/Download';

// Features Page: Detailed features
const FeaturesPage = () => {
  return (
    <>
      <Features />
      <Download />
    </>
  );
};

export default FeaturesPage;